import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import "../styles/FileUploader.scss";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useNotification } from "../../Notifications/NotificationProvider";
import DocumentsUploadIcon from "../icons/DocumentsUpload.svg";

const FileUploader = ({ onFileUpload }) => {
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const dispatchNotification = useNotification();

  const onDrop = useCallback(
    (acceptedFiles) => {
      setSelectedFile(acceptedFiles[0]);
      if (acceptedFiles && acceptedFiles.length > 0) {
        onFileUpload(acceptedFiles[0]);
      }
    },
    [onFileUpload]
  );

  const { acceptedFiles, rejectedFiles, getRootProps, getInputProps } =
    useDropzone({
      maxFiles: 1,
      accept:
        "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      init: function () {
        this.on("addedfile", function (file) {
          if (!file.type) {
            var ext = file.name.split(".").pop();
            console.log("extension: " + ext);
            if (ext === "xls") {
              Object.defineProperty(file, "type", {
                value: "application/vnd.ms-excel",
              }); // MIME type
            }
          }
        });
      },
      onDrop,
    });

  const downloadSampleFile = async () => {
    setDownloading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-service-referral`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `ServiceReferral_Sample_Template.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatchNotification({
        type: "SUCCESS",
        message: "Sample file downloaded successfully",
      });
    } catch (error) {
      console.error("Error downloading sample file:", error);
      dispatchNotification({
        type: "ERROR",
        message: "Failed to download sample file",
      });
    } finally {
      setDownloading(false);
    }
  };

  const removeFile = () => {
    setSelectedFile("");
    onFileUpload("");
  };

  return (
    <div className="service-referral-file-uploader-container">
      <img src={DocumentsUploadIcon} alt="Upload Icon" />
      <div className="file-uploader-header">
        <h3>Upload Referral Campaign Audience</h3>
        {selectedFile && (
          <div className="file-name-container">
            <p>{selectedFile.name}</p>
            <DeleteIcon className="icon-btn" onClick={removeFile} />
          </div>
        )}

        <div className="upload-actions">
          <button {...getRootProps()} disabled={!!selectedFile}>
            <input {...getInputProps()} />
            {uploading ? (
              <>
                <CircularProgress size={20} color="inherit" /> Uploading...
              </>
            ) : (
              <>
                <PublishIcon style={{ marginRight: -5 }} /> Upload *
              </>
            )}
          </button>

          <div className="download-sample-btn" onClick={downloadSampleFile}>
            {downloading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <>
                <GetAppIcon style={{ fontSize: 14 }} />
                Download Sample
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploader;
